import { HostMessageType } from '../../interfaces/host-message-types';
import { sendMessageToHost } from '../base/models/base-message';
import { MessageHandler } from '../base/interfaces/message.interface';
import { CreateTaskMessagePayload } from './interfaces/create-task-payload.interface';
import { isNonNullObject } from 'utilities';

export const CreateTaskMessage: MessageHandler<CreateTaskMessagePayload> = {
  send(payload: CreateTaskMessagePayload, targetOrigin = '*'): void {
    sendMessageToHost(HostMessageType.CreateTask, payload, targetOrigin);
  },

  validatePayload(payload: unknown): payload is CreateTaskMessagePayload {
    if (!isNonNullObject(payload)) return false;
    const p = payload as Record<string, unknown>;
    return (
      typeof p['team'] === 'string' &&
      p['team'].length > 0 &&
      typeof p['project'] === 'string' &&
      p['project'].length > 0
    );
  },
};
